import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12",
      cy: "12",
      r: "11",
      class: "primary"
    }, null, -1),
    _createElementVNode("path", {
      d: "M17.0515 11.1258C17.7373 11.5068 17.7373 12.4932 17.0515 12.8742L9.98564 16.7996C9.31911 17.1699 8.5 16.688 8.5 15.9255L8.5 8.07451C8.5 7.31203 9.31911 6.83006 9.98564 7.20036L17.0515 11.1258Z",
      class: "faded"
    }, null, -1)
  ])))
}
export default { render: render }